<div class="p-a-xl cipo--overflow--auto">
    <h2>Cipo Address Field</h2>
    <br />

    <h4>Readonly</h4>
    <div fxLayout="row wrap" fxLayoutAlign="space-between start">
        @for (control of formReadonly().controls | keyvalue; track $index) {
            <div fxFlex="32" class="m-t">
                <cipo-address [control]="control.value" />
            </div>
        }
    </div>

    <hr />
    <h4>Editable</h4>
    <div fxLayout="row wrap" fxLayoutAlign="space-between start">
        @for (control of formEditable().controls | keyvalue; track $index) {
            <div fxFlex="32" class="m-t">
                <cipo-address [control]="control.value" />
            </div>
        }
    </div>

    <hr />
    <h4>Autocomplete</h4>
    <div fxLayout="row wrap" fxLayoutAlign="space-between start">
        @for (control of formAutocomplete().controls | keyvalue; track $index) {
            <div fxFlex="32" class="m-t">
                <cipo-address [control]="control.value" />
            </div>
        }
    </div>

    <hr />
    Last value changed (JSON):
    <pre>{{ lastValueChanged() | json }}</pre>

    <div fxLayout="row wrap" fxLayoutGap="12px">
        <button mat-raised-button (click)="markAsTouched(true)">Mark all controls as touched</button>
        <button mat-raised-button (click)="markAsTouched(false)">Mark all controls as untouched</button>
    </div>
</div>
